export const formRoutePath = (routeTemplate, params) => {
  let path = routeTemplate;
  Object.keys(params).forEach((paramName) => {
    path = path.replace(`:${paramName}`, encodeURIComponent(params[paramName]));
  });
  return path;
};
